import { DirectionProvider } from "@base-ui/react/direction-provider"
import { QueryClientProvider } from "@tanstack/react-query"
import { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { Toaster } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { queryClient } from "@/lib/query"

export function Providers({ children }: { children: React.ReactNode }) {
  // Re-renders on language change so every primitive picks up the new direction.
  const { i18n } = useTranslation()
  return (
    <DirectionProvider direction={i18n.dir()}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delay={200}>
          {/* Remount on language change: formatted values (dates, money) read the language
              outside React state, so memoised output must be rebuilt. The query cache survives. */}
          <Fragment key={i18n.language}>{children}</Fragment>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </DirectionProvider>
  )
}
